import countries from 'flag-icons/country.json'
import { ControlledFormField, FormFieldCommonProps } from 'lib/types/Form'
import ComboboxInput, {
  ComboboxInputProps,
} from '../ComboboxInput/ComboboxInput'

export interface CountryInputProps
  extends Omit<FormFieldCommonProps, 'defaultValue'>,
    ControlledFormField {
  /**
   * Optional default value.
   */
  defaultValue?: string
  /**
   * Placeholder text.
   */
  placeholder?: string
  /**
   * Optional change event handler.
   */
  onChange?: ComboboxInputProps['onChange']
}

export default function CountryInput({
  name,
  label,
  control,
  onChange,
  placeholder,
  defaultValue,
  rules,
  className,
  disabled,
}: CountryInputProps) {
  return (
    <ComboboxInput
      control={control}
      name={name}
      label={label}
      placeholder={placeholder}
      rules={rules}
      options={countries.map(({ code, name }) => ({
        value: code,
        label: name,
      }))}
      defaultValue={defaultValue}
      className={className}
      disabled={disabled}
      onChange={onChange}
    />
  )
}
